import { BindingError } from "@contember/binding";
const ContentOutlet = (props) => {
  throw new BindingError(
    `BlockEditor.ContentOutlet may only appear as an immediate child of a block!

This may also happen when you change the code of your block to newly contain a ContentOutlet. Such change is generally ill-advised because there can already be data in your database that would be inconsistent with the new code.`
  );
};
export {
  ContentOutlet
};
//# sourceMappingURL=ContentOutlet.js.map
